module.exports = ".user {\n  border-radius: 50%;\n  width: 15%;\n  margin: auto;\n  margin-top: -7%;\n  z-index: 5; }\n\n@media all and (max-width: 426px) {\n  .user {\n    width: 17%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/channel-cover/channel-cover.component.scss
// module id = ./src/app/channel-cover/channel-cover.component.scss
// module chunks = main